import request from '@/middleware/request'

const getVideo = data => {
  return request({
    url: '/videos/list',
    method: 'post',
    data
  })
}

const getVideoCategory = () => {
  return request({
    url: '/videos/category',
    method: 'get'
  })
}

const updateVideo = (id, data) => {
  return request({
    url: `/videos/${id}`,
    method: 'put',
    data
  })
}

const deleteVideo = id => {
  return request({
    url: `/videos/${id}`,
    method: 'delete'
  })
}

const uploadFileVideo = formData => {
  return request({
    url: `/videos/file/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export default {
  getVideo,
  getVideoCategory,
  uploadFileVideo,
  updateVideo,
  deleteVideo
}
